<template>
    <div class="relative inline-block text-left">
        <div>
            <button ref="menuButton" @click="pop"
                    class="flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600"
                    aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                    <path
                        d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"/>
                </svg>
            </button>
        </div>
        <transition
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div v-show="isOpen" ref="menu"
                 class="z-20 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg">
                <div class="rounded-md bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical"
                     aria-labelledby="options-menu">
                    <div class="py-1">
                        <inertia-link :href="route('publisher.jobs.show', [job.display_id])"
                                      class="group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                      role="menuitem">
                            <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                                 viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"/>
                                <path fill-rule="evenodd"
                                      d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                      clip-rule="evenodd"/>
                            </svg>
                            Edit
                        </inertia-link>
                        <inertia-link preserve-scroll v-if="job.status !== 'published'" method="post" :href="route('publisher.jobs.publish', [job.display_id])"
                                      :data="{ publish: true, _method: 'patch' }"
                                      class="group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                      role="menuitem">
                            <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                                 viewBox="0 0 20 20" fill="currentColor">
                                <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"/>
                                <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"/>
                            </svg>
                            Publish
                        </inertia-link>
                    </div>
                    <div class="border-t border-gray-100"></div>
                    <div class="py-1">
                        <inertia-link preserve-scroll :href="route('publisher.jobs.delete', [job.display_id])" method="post" :data="form"
                                      class="group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                      role="menuitem">
                            <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                                 viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd"
                                      d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                      clip-rule="evenodd"/>
                            </svg>
                            Delete
                        </inertia-link>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    import {createPopper} from '@popperjs/core';

    export default {
        name: "IndexMenu",
        props: {
            job: Object
        },
        data: () => ({
            popper: null,
            isOpen: false,
            form: null
        }),
        mounted() {
          this.getFormData();
        },
        methods: {
            getFormData() {
                const form = new FormData();
                form.append('_method', 'delete');
                this.form = form;
            },
            pop() {
                this.isOpen = !this.isOpen;

                if (this.popper === null) {
                    this.popper = createPopper(this.$refs.menuButton, this.$refs.menu, {
                        placement: 'bottom-end',
                        modifiers: [
                            {
                                name: 'computeStyles',
                                options: {
                                    gpuAcceleration: true,
                                    adaptive: true,
                                },
                            }
                        ]
                    });
                }
            }
        }
    }
</script>
